import { useTranslations } from "next-intl";
import type { ReactElement } from "react";

/** "Not found" inside the help shell, for SPA targets that are not public (anymore). */
export function HelpNotFoundInline(): ReactElement {
  const t = useTranslations("public.helpArticleClient");
  return (
    <div className="mx-auto max-w-[680px] py-10">
      <h1 className="text-[22px] font-semibold tracking-tight text-primary">
        {t("seiteNichtGefunden")}
      </h1>
      <p className="mt-2 text-[13.5px] leading-relaxed text-primary/60">
        {t("dieseHilfeseiteGibtNicht")}
      </p>
    </div>
  );
}
